export default __webpack_public_path__ + "static/media/Teams-Logo.bf098d4e.svg";